export default "/images/e8c9e5c9cde12c68aa5482c0d3b39455.avif";